import React, {useState, useEffect} from 'react';
import cn from 'classnames';
import styles from './HamburgerSideBarMenu.module.scss'
import { MenuItems } from './HamburgerMenuItems';
import { APP_CONFIG } from '../../../constants/index';
import { getObjectValue, getFormatedPhoneNumber } from '@utility/helperFunction';

const HamburgerSideBarMenu = (props) => {

    const {setShowMenu, handleLogout, duplicateData, layoutApi, activeScreenType, History, handleShowRecallModal} = props;
    const [responseData, setResponseData] = useState(null);
    const [menuItemSelected, setMenuItemSelected] = useState('')

    const handleAbout = (data) => {
        const auth =  JSON.parse(window.sessionStorage.getItem('auth'))
        const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'))
        const nativeAppVersion = JSON.parse(window.sessionStorage.getItem('nativeAppVersion'))
      const dataTosend = {
        store: auth.name,
        device: deviceInfo.deviceName,
        appVersion: nativeAppVersion,
        webVersion: APP_CONFIG.VERSION,
        environment: props.environment,
          forSupport: getObjectValue(() => getFormatedPhoneNumber( auth?.supportPhoneNumber),''),
        deviceGroup: deviceInfo?.deviceGroup ? deviceInfo?.deviceGroup?.name : ''
      };
      setResponseData({data, val: dataTosend });
    };

    useEffect(() => { handleAbout() }, [])

    const handleClick = (val) => {
        switch (val) {
            case "Duplicate": {
                duplicateData();
                break;
            }
            case "Layout": {
                layoutApi();
                break;
            }
            case "History": {
                History();
                setShowMenu(false);
                break;
            }
            case "Recall": {
                handleShowRecallModal();
                setShowMenu(false);
                break;
            }
            default: {
                console.log({ val });
            }
        }
    }    

    const handleMenuVisibility = (itemName) => {
       switch(itemName){
         case "Layout": return activeScreenType === 0;
         case "Recall" : return activeScreenType === 1 || activeScreenType === 2;
         case "History" : return activeScreenType === 0;
         case "Duplicate" : return activeScreenType === 0 || activeScreenType === 1 || activeScreenType === 2;
         default: return true;
       }
    }

    return (
        <div className={cn(styles.container)}>
            <div className={cn('d-flex justify-content-between', styles.header)}>
                <div></div>
                <div role="presentation" className="p-2" onClick={() => {setShowMenu(false); setMenuItemSelected('')}}>
                <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" viewBox="0 0 512 512" style={{fill:'#000'}}><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"/></svg>
                </div>
            </div>
            <div className={cn(styles.items)}>
                {
                    MenuItems?.map(({title, icon}) => (
                       handleMenuVisibility(title) ? <div key={title} className={cn('d-flex', (menuItemSelected ===  title) && styles.menuItem)} onClick={() => {handleClick(title); setMenuItemSelected(title)}}>
                            <div className={cn(styles.menuLeftDiv, (menuItemSelected === title) && styles.menuOnSelect)}></div>
                            <div className={cn('d-flex align-items-center justify-content-center p-1',styles.icon)}>
                                {icon}    
                            </div>
                            <div className={cn('d-flex align-items-center justify-content-start p-1 fs-18',styles.iconTitle)}>{title}</div>
                        </div> : <></>
                    ))
                }
            </div>
            <div className={cn('ml-2',styles.footer)}> 
                <div className={cn( styles.deviceInfo )}>
                    <div className={cn('')}>
                        <div className='d-flex align-items-center justify-content-start ml-3 pt-4 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}} >Store: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.store || 'NA'}</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-start ml-3 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}}>Device: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.device || 'NA'}</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-start ml-3 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}}>Device Group: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.deviceGroup || 'NA'}</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-start ml-3 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}}>App Version: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.appVersion || 'NA'}</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-start ml-3 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}}>Web Version: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.webVersion || 'NA'}</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-start ml-3 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}}>Environment: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.environment || 'NA'}</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-start ml-3 pb-1'>
                            <span className={cn('fs-12 mr-1')} style={{fontWeight: 'bolder'}}>For Support: </span>
                            <span className='fs-12' style={{paddingTop: '0.1rem'}}>{responseData?.val?.forSupport || 'NA'}</span>
                        </div>
                    </div>
                </div>
                <div className={cn(styles.logout)}>
                    <button className='w-90 od-btn-primary btn20 mb-2 ml-2' onClick={() => handleLogout()}>
                        LOGOUT
                    </button>
                </div>
            </div>
        </div>
    )
}

export default HamburgerSideBarMenu;